import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { I18n, ErrorBlock } from 'components';

import { withRenderFlag } from '@beef/react';
import { compose } from 'redux';
import { getFTTBError } from '../../store/selectors';
import { fetchData as fetchDataAction } from '../../store/actions';

export const _InternetErrorBlock = ({ fetchData }) => (
  <ErrorBlock
    title={<I18n path="internet.internet.blockTitle" />}
    refreshAction={fetchData}
  />
);

_InternetErrorBlock.propTypes = {
  fetchData: PropTypes.func,
};

export const InternetErrorBlock = compose(
  connect(
    (state) => ({
      shouldRender: !!getFTTBError(state),
    }),
    { fetchData: fetchDataAction },
  ), withRenderFlag,
)(_InternetErrorBlock);
